import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(8),
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  backButton: {
    color: theme.palette.text.secondary,
  },
  title: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  mainCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  sectionTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main,
  },
  addButton: {
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1.5),
  },
  fulfillmentListCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    border: '2px solid #7B1FA2',
  },
  tableContainer: {
    marginTop: theme.spacing(2),
    borderRadius: 8,
  },
  boldText: {
    fontWeight: 600,
  },
  sideCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  sideCardTitle: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  itemSummary: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  itemProgress: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    flexWrap: 'wrap',
  },
  instructions: {
    '& p': {
      lineHeight: 1.8,
    },
  },
  actionsCard: {
    marginTop: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    position: 'sticky',
    bottom: theme.spacing(3),
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  cancelButton: {
    textTransform: 'none',
    color: theme.palette.text.secondary,
  },
  saveButton: {
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1.5, 4),
  },
}));
